import { render, staticRenderFns } from "./CallDeactiveProject.vue?vue&type=template&id=1f75be56"
import script from "./CallDeactiveProject.vue?vue&type=script&lang=js"
export * from "./CallDeactiveProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports